import type { GQL_ID } from '@@partner:types:graphql'
import type { ShopCartProduct } from '@@partner:types:app'
import type { ShopCart } from '../types'

import React, { useContext, useEffect } from 'react'
import { useCart, CartFacade } from '@@partner:helpers/hooks/useCart'

export interface CartContextValue {
  carts: ShopCart[]
}

const CartContext = React.createContext<CartFacade>({} as CartFacade)

export interface CartProviderProps {
  shop_id?: GQL_ID
  initialProducts?: ShopCartProduct[]
}

const CartProvider: React.FC<CartProviderProps> = ({
  children,
  shop_id,
  initialProducts
}) => {
  const value = useCart(shop_id)

  useEffect(() => {
    if (initialProducts && initialProducts.length > 0) {
      value.setCurrentCartProducts(initialProducts)
    }
  }, [])

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>
}

export const useCurrentCart = () => useContext(CartContext)

const CartContextConsumer = CartContext.Consumer

export { CartContext, CartProvider as CartContextProvider, CartContextConsumer }
